import React from "react";

interface PromptCardProps {
  promptNumber: number;
  promptTitle: string;
  promptText: string; // Full prompt description
  onSelect: (promptText: string) => void;
  isDisabled?: boolean;
}

export const PromptCard: React.FC<PromptCardProps> = ({
  promptNumber,
  promptTitle,
  promptText,
  onSelect,
  isDisabled = false,
}) => {
  return (
    <div className="mb-4 p-5 rounded-xl border-2 border-theme-primary bg-theme-surface shadow-md hover:shadow-lg transition-shadow animate-fadeIn">
      {/* Header with prompt number and title */}
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-theme-primary text-white flex items-center justify-center font-bold text-base flex-shrink-0">
          {promptNumber}
        </div>
        <h3 className="text-theme-fg font-semibold text-lg flex-1">
          {promptTitle}
        </h3>
      </div>

      {/* Full prompt description */}
      <div className="mb-4 p-4 bg-theme-background rounded-lg border border-theme-border">
        <p className="text-theme-fg text-sm leading-relaxed">{promptText}</p>
      </div>

      {/* Action button */}
      <button
        onClick={() => !isDisabled && onSelect(promptText)}
        disabled={isDisabled}
        className={`w-full py-3 px-4 rounded-lg font-semibold text-base flex items-center justify-center gap-2 transition-all ${
          isDisabled
            ? "bg-theme-surface text-theme-fg-muted cursor-not-allowed opacity-60"
            : "bg-theme-primary text-white hover:bg-theme-primary-hover hover:shadow-md cursor-pointer"
        }`}
      >
        Use This Prompt
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 7l5 5m0 0l-5 5m5-5H6"
          />
        </svg>
      </button>
    </div>
  );
};
